import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class NavegationPagesService {

  private pageSubject = new Subject<string>();
  page$ = this.pageSubject.asObservable();
  
  private _seleccionado = new BehaviorSubject<string>('home');
  public seleccionado$ = this._seleccionado.asObservable();

  navegationPages(pagina: string): void {
    console.log(pagina)
    this.pageSubject.next(pagina); 
  }

  seleccionado(item: string): void {
    this._seleccionado.next(item);
  }
}
